import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  openModal: false,
  CodeProduct: '',
};

const handlerResetRecomendacion = () => {
  return initialState;
};

const handlerSetTitle = (state, action) => {
  state.CodeProduct = action.payload;
};

const handlerOpenModal = (state) => {
  state.openModal = true;
};

const handlerCloseModal = (state) => {
  state.openModal = false;
}


const recomendacionSlice = createSlice({
    name: 'recomendacion',
    initialState,
    reducers: {
      reset: handlerResetRecomendacion,
      setTitle: handlerSetTitle,
      setOpenModal: handlerOpenModal,
      setCloseModal: handlerCloseModal,
    },
});

export const {
  reset,
  setTitle,
  setOpenModal,
  setCloseModal,
} = recomendacionSlice.actions;

export const recomendacionReducer = recomendacionSlice.reducer;